import React from 'react';
import { styled } from "../../stitches.config"

const GoBackToMainPage = ({
    ...props
}) => {
    return (
        <StyledBreakLine />
    );
};


const StyledBreakLine = styled('div', {
    margin: "40px 0 32px 0",
    width: "100%",
    height: "1px",
    background: "$grayscale25",
    "@bp4": {
        margin: "88px 0 80px 0",
    }
})


export default GoBackToMainPage